<template>
  <div class="enterpriselist">
    <div class="flex-end-center xin_zen">
      <el-button type="primary" @click="openEdit(null)">新增</el-button>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="id" label="序号" width="80">
        <template slot-scope="scope">
          <div>{{ scope.row.xuHao }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="企业名称"> </el-table-column>
      <el-table-column prop="legalPerson" label="法定代表人" width="100">
      </el-table-column>
      <el-table-column prop="contactPhone" label="联系方式" width="120">
      </el-table-column>
      <el-table-column prop="code" label="统一社会信用代码" width="180">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <div v-show="scope.row.status == 0">审核中</div>
          <div v-show="scope.row.status == 1">已通过</div>
          <div v-show="scope.row.status == 2">未通过</div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 2"
            size="mini"
            type="success"
            plain
            @click="handleEdit(scope.$index, scope.row)"
          >
            修改申请
          </el-button>
          <el-button
            v-else-if="scope.row.status == 0 || scope.row.status == 1"
            size="mini"
            type="primary"
            plain
            @click="handleEdit(scope.$index, scope.row, 1)"
          >
            查看申请
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="dialogVisible" width="80%">
      <enterprise-edit @close="editShow" :data="editData" :type="type" :etype="etype" />
    </el-dialog>
  </div>
</template>

<script>
import EnterpriseEdit from "./EnterpriseEdit.vue";
import { getRequest, postRequest } from "../api/api";
export default {
  components: { EnterpriseEdit },
  props: ["type"],
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      editData: null,
      etype: null, //判断是修改新增还是查看(1)
      page: {
        page: 0,
        size: 99,
      },
    };
  },
  methods: {
    handleEdit(index, row, type) {
      console.log(index, row);
      this.openEdit(row, type);
    },
    openEdit(data, type = null) {
      this.dialogVisible = true;
      this.editData = data;
      this.etype = type;
    },
    editShow() {
      this.getList();
      this.dialogVisible = false;
    },
    getList() {
      let data = this.page;
      if (!this.type) {
        data.type = 0;
      } else {
        data.type = 1;
      }
      getRequest({ url: "/api/v1/auth/enterprise/page", data }).then((res) => {
        if (res.errcode == 200) {
          this.tableData = res.data.map((item, index) => {
            item.xuHao = index + 1;
            return item;
          });
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
  },
  created() {
    console.log("调用列表");
    this.getList();
  },
};
</script>

<style lang="scss">
.enterpriselist {
  .xin_zen {
    .el-button {
      padding: 8px 25px;
    }
  }
}
</style>
